import React from "react";
import { toast } from "react-toastify";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import { addReactivatePersonalInfoApi } from "designs/v1/pages/ModifyKyc/services";

const PersonalDetails = ({
  activeUserDetail,
  isLoading,
  setIsLoading,
  setStep,
}) => {
  const OCCUPATION_TYPES = [
    "Private Sector",
    "Public Sector",
    "Government Sector",
    "Professional",
    "Agriculturist",
    "Business",
    "Retired",
    "Housewife",
    "Student",
    "Others",
  ];
  const initialValues = {
    occupation: "",
    other_occupation: "",
  };

  const handleValidate = (values) => {
    const errors = {};
    if (!values.occupation) {
      errors.occupation = "Occupation is required.";
    }
    if (values.occupation === "Others" && !values.other_occupation) {
      errors.other_occupation = "Others occupation is required.";
    }
    return errors;
  };

  const handleSubmit = async (value) => {
    setIsLoading(true);
    const formValue = {
      doc_name: activeUserDetail?.request_number,
      ...value,
    };
    try {
      await addReactivatePersonalInfoApi(formValue);
      toast.success("Personal Details saved successfully.");
      setIsLoading(false);
      setStep("IncomeProof");
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message || "Internal server error!");
      setIsLoading(false);
    }
  };

  return (
    <>
      <Title title="Personal Details" />
      <div className="row">
        <div className="col-md-9">
          <div className="form-group">
            <div className="mb-2">
              <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validate={handleValidate}
                onSubmit={handleSubmit}
              >
                {({ values }) => (
                  <Form>
                    <div className="col-sm form-group my-2">
                      <label>
                        Occupation
                        <span className="text-danger">*</span>
                      </label>
                      <Field
                        as="select"
                        name="occupation"
                        type="text"
                        className="form-select"
                      >
                        <option value={""}>Select an option</option>
                        {OCCUPATION_TYPES.map((item) => {
                          return (
                            <option
                              key={item}
                              value={item}
                            >
                              {item}
                            </option>
                          );
                        })}
                      </Field>
                      <ErrorMessage
                        name="occupation"
                        className="inline-errormsg my-1"
                        component="div"
                      />
                    </div>
                    {values.occupation === "Others" && (
                      <div className="col-sm form-group my-2">
                        <label>
                          Please enter other occupation
                          <span className="text-danger">*</span>
                        </label>
                        <Field
                          name="other_occupation"
                          type="text"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="other_occupation"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>
                    )}
                    <div className="d-flex form-group my-4">
                      <div className="">
                        <Button
                          type="button"
                          title="Back"
                          handleClick={() => setStep("AddressProof")}
                          disabled={isLoading}
                        />
                      </div>
                      <div className="mx-2">
                        <Button
                          title="Submit"
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalDetails;
